/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=7c6cd8b2&scoped=true&"
import script from "./Classroom.vue?vue&type=script&lang=js&"
export * from "./Classroom.vue?vue&type=script&lang=js&"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=7c6cd8b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6cd8b2",
  null
  
)

export default component.exports